module.exports = __webpack_public_path__ + "img/bls-3.b722a436.png";